import React, { useState } from 'react';
import Header from '../components/header';
import PageMenu from '../components/pagemenu';
import ErrorBoundary from '../components/ErrorBoundary';
import { useUserContext } from '../components/UserContext';
import PortalAdmin from '../components/portal/PortalAdmin';

// Commercial portal setup, reached from the header menu. Admins only.
function Portal() {
  const { user } = useUserContext();
  const [isAuthenticated, setIsAuthenticated] = useState(Boolean(localStorage.getItem('authToken')));

  let content = <div>Please log in to view content</div>;
  if (isAuthenticated && user && !user.is_admin) content = <div className="App-message">Only admins can set up the commercial portal.</div>;
  else if (isAuthenticated && user) content = <ErrorBoundary><PortalAdmin /></ErrorBoundary>;
  else if (isAuthenticated) content = null;

  return (
    <div className="App">
      <Header isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      {content}
      <PageMenu className="bottom-nav" />
    </div>
  );
}

export default Portal;
